import { render } from "./equality-report-gender-distribution.vue?vue&type=template&id=9bf1a9be"
import script from "./equality-report-gender-distribution.vue?vue&type=script&lang=js"
export * from "./equality-report-gender-distribution.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/equality/equality-report-gender-distribution.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9bf1a9be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9bf1a9be', __exports__)) {
    api.reload('9bf1a9be', __exports__)
  }
  
  module.hot.accept("./equality-report-gender-distribution.vue?vue&type=template&id=9bf1a9be", () => {
    api.rerender('9bf1a9be', render)
  })

}


export default __exports__